import { Display } from "rot-js"
import { PlayerAction, PlayerBody } from "../defines/enums"
import { Offset, TapestryTile } from "../defines/types"
import { EngineDefaults } from "../defines/values"
import { BLACK_TILE, BORDER_TILE } from "../map/tile"
import { toDisplayString } from "../utils/color"
import { displayOptic } from "../utils/player"
import { Popup } from "./popup"

export class Loadout extends Popup {
  private _tiles: TapestryTile[][] = []

  constructor(offsets: Offset, name: string) {
    super(
      EngineDefaults.TROPHY_CASE_WIDTH,
      EngineDefaults.TROPHY_CASE_HEIGHT,
      offsets,
      name
    )
    this.initTiles()
  }

  prepareToRender(): void {
    return
  }

  postRender(): void {}

  render(display: Display): void {
    for (let y = 0; y < this._tiles.length; ++y) {
      const row = this._tiles[y]
      for (let x = 0; x < row.length; ++x) {
        const tile = row[x]
        display.draw(
          x + this.offsets.xOffset,
          y + this.offsets.yOffset,
          tile.symbol,
          toDisplayString(tile.fg),
          toDisplayString(tile.bg)
        )
      }
    }

    const colors: string = "%c{#fff}%b{#000}"
    const title: string = "Equipment Loadout"
    let printRow: number = 1
    let xStart: number = this.width / 2 - title.length / 2

    display.drawText(xStart, printRow, colors + title)

    let output: string = `Your current loadout.`

    printRow += 2
    xStart = this.width / 2 - output.length / 2
    display.drawText(xStart, printRow, colors + output)

    printRow += 1
    xStart = this.offsets.xOffset + 1
    display.drawText(
      xStart,
      printRow,
      colors + "-".padEnd(this.width - 2, "-") // 2 accounts for walls
    )

    xStart += 1

    const none = "none"

    const player = window.engine.getPlayer()

    let head = none
    const headItem = player.getEquipment(PlayerBody.HEAD)
    if (headItem !== undefined) {
      head = headItem.name
    }

    let torso = none
    const torsoItem = player.getEquipment(PlayerBody.TORSO)
    if (torsoItem !== undefined) {
      torso = torsoItem.name
    }

    let feet = none
    const feetItem = player.getEquipment(PlayerBody.FEET)
    if (feetItem !== undefined) {
      feet = feetItem.name
    }

    let lHand = none
    const lHandItem = player.getEquipment(PlayerBody.LEFT_HAND)
    if (lHandItem !== undefined) {
      lHand = lHandItem.name
      if (lHandItem.twoHanded) {
        lHand += " (two-handed)"
      }
    }

    let rHand = none
    const rHandItem = player.getEquipment(PlayerBody.RIGHT_HAND)
    if (rHandItem !== undefined) {
      rHand = rHandItem.name
    }

    printRow += 2

    const longestLabel = "Right hand:".length + 1
    const padColors = `%c{#000}%b{#000}`
    let label = "Head:"
    let pad = ".".padEnd(longestLabel - label.length, ".")

    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ${head}`
    )

    printRow += 2
    label = "Torso:"
    pad = ".".padEnd(longestLabel - label.length, ".")
    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ${torso}`
    )

    printRow += 2
    label = "Feet:"
    pad = ".".padEnd(longestLabel - label.length, ".")
    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ${feet}`
    )

    printRow += 2
    label = "Left hand:"
    pad = ".".padEnd(longestLabel - label.length, ".")
    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ${lHand}`
    )

    printRow += 2
    label = "Right hand:"
    pad = ".".padEnd(longestLabel - label.length, ".")
    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ${rHand}`
    )

    printRow += 2
    label = "Optic:"
    pad = ".".padEnd(longestLabel - label.length, ".")
    display.drawText(
      xStart,
      printRow,
      padColors + pad + `%c{#fff}%b{#000}${label} ` + displayOptic(player)
    )
  }

  update(action: PlayerAction): void {}

  protected initTiles() {
    this._tiles = new Array(this.height)
    for (let y = 0; y < this.height; y++) {
      const row = new Array(this.width)
      for (let x = 0; x < this.width; x++) {
        const isWall =
          x === 0 || x === this.width - 1 || y === 0 || y === this.height - 1
        row[x] = isWall ? { ...BORDER_TILE } : { ...BLACK_TILE }
      }
      this._tiles[y] = row
    }
  }
}
